import { SerializedStyles } from '@emotion/core'

import { isDesktop } from '../helpers/common'
import { AdGalleryContentProps } from './newAdPages'

// export for ImageGallery.tsx component
export interface GalleryImageItemProps {
  title: { en: string; fr?: string; de?: string }
  description?: { en: string; fr?: string; de?: string }
  linkText?: { en: string; fr?: string; de?: string }
  linkURL?: string
  imgSrc: string
  imgStyle?: React.CSSProperties
  imageCss?: SerializedStyles
}

export const airfocusWayImages: GalleryImageItemProps[] = [
  {
    title: {
      en: 'You need a dedicated area for each of <br class="hide-on-small-medium-large" /> your teams or products?',
    },
    description: { en: `Spin up as many interconnected workspaces ${isDesktop(1030) && '<br />'} as you need.` },
    imgSrc: 'features/roadmaps/portfolio.webp',
    imgStyle: { margin: 'auto' },
  },
  {
    title: { en: 'You need to see your board as a timeline?' },
    description: { en: 'Just add a new view for the same data.' },
    imgSrc: 'airfocus-way/timeline-board.webp',
    imgStyle: { margin: 'auto' },
  },
  {
    title: { en: 'You need a way to group your features?' },
    description: { en: 'Simply configure a custom field to do that.' },
    imgSrc: 'airfocus-way/group-features.webp',
    imgStyle: { margin: 'auto' },
  },
  {
    title: { en: 'You need a custom roadmap for C-level?' },
    description: {
      en: 'Generate around a dynamic & secure share link <br class="hide-on-small-medium-large" /> in seconds.',
    },
    imgSrc: 'ad-pages/roadmaps-views.webp',
    imgStyle: { margin: 'auto' },
  },
  {
    title: { en: 'You need an inclusive way to prioritize?' },
    description: { en: 'Extend your workspace with the <br class="hide-on-small-medium-large" /> Priority Poker app.' },
    imgSrc: 'airfocus-way/prioritize-inclusive.webp',
    imgStyle: { margin: 'auto' },
  },
]

export const homepageValuesGalleryContent: AdGalleryContentProps[] = [
  {
    name: {
      en: 'SINGLE SOURCE OF <span class="hide-on-small-medium-large">&nbsp;(PRODUCT)&nbsp;</span> TRUTH',
      fr: 'UNE SEULE SOURCE DE VÉRITÉ <span class="hide-on-small">&nbsp;PRODUIT</span>',
      de: 'EINE SINGLE SOURCE OF TRUTH <span class="hide-on-small">&nbsp;FÜR EUER PRODUKT</span>',
    },
    title: {
      en: 'Bring everything you need for roadmapping - <br class="hide-on-small hide-on-large-desktop" /> even Jira - under one roof',
      fr: 'Tout ce dont vous avez besoin pour vos roadmaps <br class="hide-on-small hide-on-large-desktop" /> - même Jira - sous un même toit',
      de: 'Vereint alles, was ihr für Roadmapping braucht - <br class="hide-on-small hide-on-large-desktop" /> inklusive Jira - an einem Ort',
    },
    description: {
      en: 'No matter how many different workflows and dependencies you have, you can <br class="hide-on-small hide-on-large-desktop" /> finally keep everyone in sync: click through from company OKRs down <br class="hide-on-small hide-on-large-desktop" /> to a single user story & delivery - all in one place.',
      fr: "Quel que soit le nombre de workflows différents et de dépendances que <br class='hide-on-small hide-on-large-desktop' /> vous avez, vous pouvez enfin tous les synchroniser : naviguez des <br class='hide-on-small hide-on-large-desktop' /> OKRs de l'entreprise jusqu'à une seule User Story dans Jira - <br class='hide-on-small hide-on-large-desktop' /> tout cela en un seul endroit.",
      de: 'Unabhängig davon, wie viele verschiedene Workflows und Abhängigkeiten es <br class="hide-on-small hide-on-large-desktop" /> gibt - ihr könnt endlich alle auf dem gleichen Stand halten: Klickt euch <br class="hide-on-small hide-on-large-desktop" /> von den OKRs des Unternehmens bis hin zu einer einzelnen <br class="hide-on-small hide-on-large-desktop" /> User Story in Jira durch - alles an einem Ort.',
    },
    imgSrc: 'abstract/roadmap.webp',
  },
  {
    name: {
      en: '<span class="hide-on-small-medium">ROADMAP&nbsp;</span> VISIBILITY AT EVERY LEVEL',
      fr: 'VISIBILITÉ <span class="hide-on-small">&nbsp;DE LA ROADMAP&nbsp;</span>À TOUS LES NIVEAUX',
      de: '<span class="hide-on-small">&nbsp;ROADMAP&nbsp;</span> SICHTBARKEIT AUF ALLEN EBENEN',
    },
    title: {
      en: 'Slice & dice your roadmaps for every stakeholder - <br class="hide-on-small hide-on-large-desktop" /> with just a few clicks',
      fr: "Préparez vos roadmaps pour chaque partie <br class='hide-on-small hide-on-large-desktop' /> prenante en seulement quelques clics.",
      de: 'Passt eure Roadmaps für alle Stakeholder an - <br class="hide-on-small hide-on-large-desktop" /> mit nur wenigen Klicks!',
    },
    description: {
      en: 'With our flexible filters and sharing options, you can easily share <br class="hide-on-small hide-on-large-desktop" /> interactive, real-time roadmaps in different formats - <br class="hide-on-small hide-on-large-desktop" /> giving every stakeholder the visibility they need.',
      fr: "Grâce à nos filtres et options de partage flexibles, les roadmaps sont interactives <br class='hide-on-small hide-on-large-desktop' /> en temps réel, et peuvent être facilement partagées dans différents formats, <br class='hide-on-small hide-on-large-desktop' /> ce qui permet à toutes les parties prenantes d'avoir la vue <br class='hide-on-small hide-on-large-desktop' /> d'ensemble dont elles ont besoin.",
      de: 'Mit unseren flexiblen Filtern und Freigabeoptionen könnt ihr interaktive Echtzeit-<br class="hide-on-small hide-on-large-desktop" />Roadmaps ganz einfach in verschiedenen Formaten teilen - und gebt euren <br class="hide-on-small hide-on-large-desktop" /> Stakeholdern genau die Sichtbarkeit, die sie benötigen.',
    },
    imgSrc: 'abstract/sharing.webp',
  },
  {
    name: {
      en: 'INSIGHTS-DRIVEN &nbsp;<span class="hide-on-small-medium-large">PRODUCT-MANAGEMENT</span> <span class="hide-on-medium hide-on-desktop">PM</span>',
      fr: '<span class="hide-on-small">LAISSEZ VOS UTILISATEURS GUIDER LA GESTION PRODUIT</span><span class="hide-on-medium-large-desktop">CONSTRUISEZ AVEC VOS CLIENTS</span>',
      de: 'INSIGHTS-GESTÜTZTES <span class="hide-on-small">&nbsp;PRODUKTMANAGEMENT</span><span class="hide-on-medium-large-desktop">&nbsp;PM</span>',
    },
    title: {
      en: "Connect the dots between customer insights and <br class='hide-on-small hide-on-large-desktop' /> roadmap prioritization - <br class='hide-on-small-medium' /> in one view",
      fr: 'Connectez les retours des clients et la priorisation <br class="hide-on-small hide-on-large-desktop" /> de la roadmap en une seule vue',
      de: 'Verbindet Kunden-Insights mit Roadmap-<br class="hide-on-small hide-on-large-desktop" />Priorisierung - alles in einer einzigen Ansicht',
    },
    description: {
      en: "Be transparent about how customer feedback shapes your roadmap. Clearly trace <br class='hide-on-small hide-on-large-desktop' /> any roadmap or prioritization decision back to its source and insights, helping <br class='hide-on-small hide-on-large-desktop' /> stakeholders understand the \"why\" while maintaining visibility into the original feedback.",
      fr: 'Mettez en évidence comment les retours client influencent votre roadmap. Ainsi, <br class="hide-on-small hide-on-large-desktop" /> les parties prenantes comprennent le « pourquoi » derrière la priorisation <br class="hide-on-small hide-on-large-desktop" /> sans oublier la requête initiale grâce à une tracabilité parfaite.',
      de: "Macht deutlich, wie Kunden-Insights die Roadmap beeinflussen. <br class='hide-on-small hide-on-large-desktop' /> Verfolgt Kundenfeedback nahtlos bis zu den Roadmap-<br class='hide-on-small hide-on-large-desktop' />Entscheidungen zurück und helft euren Stakeholdern, <br class='hide-on-small hide-on-large-desktop' /> das 'Warum' hinter der Priorisierung zu verstehen.",
    },
    imgSrc: 'abstract/insights.webp',
  },
]
